export const getCoursesUrl = ({
  page = 1,
  limit = 50,
  level,
  categoryId,
  materialType,
}) =>
  `/api/v1/courses?page=${page}&limit=${limit}${
    level && level !== 'all' ? `&level=${level}` : ''
  }${categoryId && categoryId !== 'all' ? `&category_id=${categoryId}` : ''}${
    materialType && materialType !== 'all' ? `&filter=${materialType}` : ''
  }`

export const showCourseUrl = param => `/api/v1/courses/${param}`
